// extracted by mini-css-extract-plugin
export default {"boxAd":"DataAdvertisement-module--boxAd--WmKRs","textAbout":"DataAdvertisement-module--textAbout--0YPAQ","whatsappButton":"DataAdvertisement-module--whatsappButton--xugGx"};